import { Injectable } from '@angular/core';
import { GridType } from '@app/pcs/models';
import * as fromRoot from '@app/reducer';
import { select, Store } from '@ngrx/store';
import { hasValue, safeProp } from '@util';
import { DataGridColumn, getGridColumns, getGridPagination, getSelectedData, hasData } from 'ngrx-data-grid';
import * as R from 'ramda';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

const toColumnFields: any = R.compose(
  R.map(R.prop('field')),
  R.filter(R.prop('visible'))
);

type ToIds = (items: any[]) => number[];
const toIds: ToIds = R.map(safeProp('id'));

@Injectable()
export class GridService {

  gridState$ = this.store.pipe(select(fromRoot.getGridState));

  constructor(private store: Store<fromRoot.State>) {
  }

  getSelectedData(gridName: GridType): Observable<any> {
    return this.gridState$.pipe(select(getSelectedData, {gridName}));
  }

  getSelectedIds(gridName: GridType, toIdsFn = toIds): Observable<number[]> {
    return this.getSelectedData(gridName).pipe(map(toIdsFn));
  }

  hasData(gridName: GridType): Observable<any> {
    return this.gridState$.pipe(select(hasData, {gridName}));
  }

  hasSelectedData(gridName: GridType): Observable<boolean> {
    return this.getSelectedData(gridName).pipe(map(hasValue));
  }

  getGridColumns(gridName: GridType): Observable<DataGridColumn[]> {
    return this.gridState$.pipe(select(getGridColumns, {gridName}));
  }

  getGridVisibleColumnNames(gridName: GridType): Observable<string[]> {
    return this.gridState$.pipe(
      select(getGridColumns, {gridName}),
      filter(hasValue),
      map(toColumnFields)
    );
  }

  getGridPagination(gridName: GridType): Observable<any> {
    return this.gridState$.pipe(select(getGridPagination, {gridName}));
  }
}
